module.exports = __webpack_public_path__ + "images/tour/activity_privacy-633f35d8cf05d006e14e50fa630c15b4.gif";